import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const TIFCVerifiedApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Vefified Applications(TIFC)"
        status={[applicationStatusMap?.tifcVerified.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default TIFCVerifiedApplications;
